import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import { Select, Input, Button } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class AssetServiceAlertsFilterForm extends Component {
    constructor (props) {
        super(props);
        let currentAssetFilters = null;
        if (props?.assetViewServiceAlertFilters?.length) {
            const matches = props.assetViewServiceAlertFilters.filter(f => parseInt(f.assetId) === parseInt(props.assetId));
            if (matches?.length) {
                currentAssetFilters = matches[0]?.filters;
            }
        }
        this.state = { currentAssetFilters };
    }

    componentDidUpdate(prevProps) {
        const { assetViewServiceAlertFilters, assetId } = this.props;
        
        if (prevProps.assetViewServiceAlertFilters !== assetViewServiceAlertFilters) {
            let currentAssetFilters = null;
            if (assetViewServiceAlertFilters?.length) {
                const matches = assetViewServiceAlertFilters.filter(f => parseInt(f.assetId) === parseInt(assetId));
                if (matches?.length) {
                    currentAssetFilters = matches[0]?.filters;
                }
            }
            this.setState({ currentAssetFilters });
        }
    }

    submitForm = (e) => {
        const { onSubmit } = this.props;
        
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    };

    render() {
        const { form } = this.props;
        const { currentAssetFilters } = this.state;
        
        const { getFieldDecorator } = form;

        return (
            <Form 
                onSubmit={this.submitForm} 
                layout="vertical"
            >
                <Form.Item label="Name">
                    {getFieldDecorator('alert_name', { initialValue: currentAssetFilters?.alert_name || null })(
                        <Input 
                            placeholder="Enter Name"
                            data-testid='asset-details-service-alert-filter_name-input'
                        />,
                    )}
                </Form.Item>
                <Form.Item label="Description">
                    {getFieldDecorator('alert_description', { initialValue: currentAssetFilters?.alert_description || null })(
                        <Input 
                            placeholder="Enter Description" 
                            data-testid='asset-details-service-alert-filter_description-input'
                        />
                    )}
                </Form.Item>
                <Form.Item label="Alert frequency">
                    {getFieldDecorator('frequency', { initialValue: currentAssetFilters?.frequency || null })(
                        <Select
                            placeholder="Select Frequency"
                            data-testid='asset-details-service-alert-filter_frequency-select'
                        >
                            <Select.Option value="2">Monthly</Select.Option>
                            <Select.Option value="1">Quarterly</Select.Option>
                            <Select.Option value="0">Yearly</Select.Option>
                        </Select>
                    )}
                </Form.Item>
                <div className="mt-2 mb-1 text-center">
                    <Button
                        htmlType="submit"
                        type="primary"
                        data-testid='asset-details-service-alert-filter_filter-btn'
                    >
                        Filter
                    </Button>
                </div>
            </Form>
        );
    }
}

const AssetServiceAlertsFilter = Form.create({ name: 'event_filter_form' })(AssetServiceAlertsFilterForm);

AssetServiceAlertsFilter.propTypes = {
    assetViewServiceAlertFilters: PropTypes.object,
    assetId: PropTypes.number,
    form: PropTypes.object,
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        assetViewServiceAlertFilters: state.asset.assetViewServiceAlertFilters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AssetServiceAlertsFilter);
